import React, { useState, useEffect } from "react";
import Dashboard, { getOverviewFS, getOverviewTS, IOverview } from "../../../services/api/Dashboard";
import Year, { IYear } from "../../../services/api/Year";
import Month, { IMonth } from "../../../services/api/Month";
import Formatter from "../../../services/utils/Formatter";
import Select from "../../../components/Form/Select";
import Waterfall from "./charts/Waterfall";
import Loading from "../../../components/Loading";
import { Button } from "@amcharts/amcharts4/core";

const Overview: React.FC = () => {
	const [loading, isLoading] = useState<Boolean>(true);
	const [years, setYears] = useState<IYear[]>([]);
	const [months, setMonths] = useState<IMonth[]>([]);
	const [current, setOverview] = useState<IOverview|null>(null);
	const [currentYTD, setOverviewYTD] = useState<IOverview | null>(null);

	const [year, setYear] = useState<number>(0);
	const [month, setMonth] = useState<number>(0);
	const [forecast, setForecast] = useState<string>("FW1");
	const [tweek, setTypeWeek] = useState<string>("F");
	const [tstype1, setType1] = useState<string>("BP");
	const [tstype2, setType2] = useState<string>("BP");
	const [tstype3, setType3] = useState<string>("BP");
	const [tstype4, setType4] = useState<string>("BP");
	const [tstype5, setType5] = useState<string>("BP");
	const [tstype6, setType6] = useState<string>("BP");
	const [tsWeek1, setWeek1] = useState<string>("FW1");
	const [tsWeek2, setWeek2] = useState<string>("FW1");
	let tradeSalesForecast = 0;
	let tradeSalesLastYear = 0;
	let tradeSalesReference = 0;
	let financialSalesForecast = 0;
	let financialSalesLastYear = 0;
	let financialSalesReference = 0;
	//const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

	const date = new Date();

	async function LoadOverview(year: number, month: number) {
		Promise.all([
			Dashboard.GetOverview("LATAM", year, month),
			Dashboard.GetYTDOverview("LATAM", year, month)
		])
		.then((value) => {		
			setOverview(value[0]);
			setOverviewYTD(value[1]);
		})
		.catch(console.log);
		
		tradeSalesForecast = 0;
		tradeSalesLastYear = 0;
		tradeSalesReference = 0;
		financialSalesForecast = 0;
		financialSalesLastYear = 0;
		financialSalesReference = 0;
	}

	useEffect(() => {
		isLoading(true);
		Promise.all([Year.GetAll(), Month.GetAll()])
			.then((value) => {
				const years = value[0].filter((value) => { return value.active });
				setYears(years);
				setMonths(value[1]);

				setYear(years[0].name);
				setMonth(date.getMonth() + 1);
			})
			.catch(console.log);
	}, []);

	useEffect(() => {
		isLoading(true);
		if (year > 0 && month > 0)
			LoadOverview(year, month);
	}, [year, month]);

	useEffect(() => {
		if (current != null && currentYTD != null)
			isLoading(false);
	}, [current, currentYTD]);

	function getWeekGraphData(target: IOverview[], week:string): any {
		const graphData: any = [];
		let g2Total: number = 0;
		let g2FC: number = 0;

		target.forEach((obj: IOverview) => {
			const valueBase: number = getOverviewTS(obj, tstype4);
			const tsValue: number =
				week === "FW4" ? obj.tradeSalesForecastWeek4 :
				week === "FW3" ? obj.tradeSalesForecastWeek3 :
				week === "FW2" ? obj.tradeSalesForecastWeek2 :
				week === "FW1" ? obj.tradeSalesForecastWeek1 :
				obj.tradeSalesActual;

			g2FC += tsValue;
			g2Total += valueBase;

			if (graphData.length === 0)
				graphData.push({
					category: obj.name,
					value: tsValue - valueBase
				});
			else
				for (let ii = 0; ii <= graphData.length; ii++) {
					if (ii === graphData.length || (tsValue - valueBase) >= graphData[ii].value) {
						graphData.splice(ii, 0, {
							category: obj.name,
							value: tsValue - valueBase
						});
						break;
					}
				}
		});

		graphData.splice(0, 0, {
			category: tstype4,
			value: g2Total
		});
		graphData.push({
			category: "Forecast",
			value: g2FC
		});

		return graphData;
	}

	function computeChartData(obj: IOverview, tsValue: number, fsValue: number) {
		//#region GRAPHS

		//Graph 01
		const valueBaseG: number = getOverviewTS(obj, tstype2);

		const gv: number = tsValue - valueBaseG;
		const lastItem: number = graph1Data.length - 1;
		for (let ii = 1; ii <= lastItem; ii++) {
			if (gv >= graph1Data[ii].value || ii === lastItem) {
				graph1Data.splice(ii, 0, {
					category: obj.name,
					value: gv
				});
				break;
			}
		}

		//Graph 05
		const valueBaseGFS: number = getOverviewFS(obj, tstype5);

		const gvFS: number = fsValue - valueBaseGFS;
		const lastItemFS: number = graph5Data.length - 1;
		for (let ii = 1; ii <= lastItemFS; ii++) {
			if (gvFS >= graph5Data[ii].value || ii === lastItemFS) {
				graph5Data.splice(ii, 0, {
					category: obj.name,
					value: gvFS
				});
				break;
			}
		}

		//#endregion
	}

	function mapList(obj: any): any {
		return { value: obj.id, label: obj.name };
	}

	function mapSalesMajor(parentObj: string, obj: IOverview, objYTD: IOverview): any {

		const valueBase: number = getOverviewTS(obj, tstype1);
		const valueBaseFS: number = getOverviewFS(obj, tstype1);
		const valueBaseYTD: number = getOverviewTS(objYTD, tstype1);
		const valueBaseYTDFS: number = getOverviewFS(objYTD, tstype1);

		const tsValue: number = getForecast(obj, forecast, false);
		
		// Se FCT for 0 ignorar valor do YTD
		const tsValueYTD: number = !obj.isApproved ? 0 : getForecastYTD(objYTD, forecast, false, obj);
/*
		if(obj.code == 'BRA')
		console.log(obj.name, objYTD.name, obj, objYTD, '_____',
			"objYTD.tradeSalesActual:", objYTD.tradeSalesActual,
			"obj.tradeSalesActual:", obj.tradeSalesActual,
			"obj.tradeSalesForecastWeek1:", obj.tradeSalesForecastWeek1,
			"CALC:", objYTD.tradeSalesActual - obj.tradeSalesActual + obj.tradeSalesForecastWeek1,
			"tsValueYTD: ", tsValueYTD);
*/
		const fsValue: number = getForecast(obj, forecast, true);
		
		const fsValueYTD: number = !obj.isApproved ? 0 : getForecastYTD(objYTD, forecast, true, obj);
			
		//console.log(tsValueYTD, objYTD);

		let valueLYBase: number = 0;
		let tsValueLY: number = 0;
		let fsValueLY: number = 0;
		let valueBaseLYYTD: number = 0;
		let tsValueLYYTD: number = 0;
		let fsValueLYYTD: number = 0;

		if (obj.lastYear != null) {
			valueLYBase = getOverviewTS(obj.lastYear, tstype1);
			tsValueLY = getForecast(obj.lastYear, forecast, false);
			fsValueLY = getForecast(obj.lastYear, forecast, true);
		}

		if (objYTD.lastYear != null) {
			valueBaseLYYTD = getOverviewTS(objYTD.lastYear, tstype1);
			tsValueLYYTD = getForecastYTD(objYTD.lastYear, forecast, false, obj);
			fsValueLYYTD = getForecastYTD(objYTD.lastYear, forecast, true, obj);
		}

		if(obj.children == null){
			tradeSalesForecast += tsValueYTD;
			tradeSalesLastYear += tsValueLY;
			tradeSalesReference += valueBaseYTD;

			financialSalesForecast += fsValueYTD;
			financialSalesLastYear += tsValueLYYTD;
			financialSalesReference += valueBaseYTDFS;
		}

		if (obj.level == 1)
			computeChartData(obj, tsValue, fsValue);

		//has children
		//var isParent = parentObj.code != 'LATAM' && parentObj.children != null;
		//var rowClass = isParent ? "childrenRow childrenRow-" + parentObj.id : "";

		var rowClass = obj.code != "LATAM" && parentObj != "" ? "childrenRow childrenRow-" + parentObj : "";
		var childrenCollapse = obj.children != null ? (
			<React.Fragment key={'child' + obj.id}>
				{obj.children.map((childObj: IOverview, i: number) => mapSalesMajor(parentObj + "-" + obj.id, childObj, objYTD.children[i]))}
			</React.Fragment>
		) : null;

		var childrenCollapseButton = obj.children != null ? (
			<span><a className="childrenButton" data-row-class={"childrenRow-" + parentObj + "-" + obj.id} onClick={toggleChildren} title="Toggle">{obj.name}</a></span>
		) : <span>{obj.name}</span>;

		function toggleChildren(e: any) {
			e.target.classList.toggle("childrenButton--open");
			var isOpen = e.target.classList.contains("childrenButton--open");

			//hide or show row
			document.querySelectorAll("[class^='childrenRow " + e.target.dataset.rowClass + "']").forEach(element => {
				
				//close all descendant buttons
				element.querySelectorAll(".childrenButton").forEach(bt => {bt.classList.remove("childrenButton--open")});

				if (isOpen) {
					//show only imediate children
					if(element.classList.contains(e.target.dataset.rowClass)){
						element.classList.add("childrenRow--hidden");
						element.classList.remove("childrenRow--open")
					}
				}
				else {
					//close all descendants
					element.classList.remove("childrenRow--hidden");
					element.classList.add("childrenRow--open");
				}

			});
		}
		
		//display value if forecast is not approved
		var notApprovedValue = '0';

		return (
			<React.Fragment key={obj.id}>
				<tr className={rowClass}>
					<td className="table__data--small">
						{childrenCollapseButton}
					</td>

					<td>{Formatter.DisplayValue(tsValue)}</td>
					<td>{Formatter.DisplayPercent((tsValue / tsValueLY - 1) * 100)}</td>
					<td className="table__data--border">{Formatter.DisplayPercent((tsValue / valueBase - 1) * 100)}</td>

					{/* TRADE YTD */}
					<td>{obj.isApproved ? Formatter.DisplayValue(tsValueYTD) : notApprovedValue}</td>
					<td>{obj.isApproved ? Formatter.DisplayPercent((tsValueYTD / tsValueLYYTD - 1) * 100) : notApprovedValue}</td>
					<td className="table__data--border">{obj.isApproved ? Formatter.DisplayPercent((tsValueYTD / valueBaseYTD - 1) * 100) : notApprovedValue}</td>
					
					<td className="table__separator"></td>
					
					<td>{obj.isApproved ? Formatter.DisplayValue(fsValue) : notApprovedValue}</td>
					<td>{obj.isApproved ? Formatter.DisplayPercent((fsValue / fsValueLY - 1) * 100) : notApprovedValue}</td>
					<td className="table__data--border">{obj.isApproved ? Formatter.DisplayPercent((fsValue / valueBaseFS - 1) * 100) : notApprovedValue}</td>

					{/* FINANCIAL YTD */}
					<td>{obj.isApproved ? Formatter.DisplayValue(fsValueYTD) : notApprovedValue}</td>
					<td>{obj.isApproved ? Formatter.DisplayPercent((fsValueYTD / fsValueLYYTD - 1) * 100) : notApprovedValue}</td>
					<td className="table__data--border">{obj.isApproved ? Formatter.DisplayPercent((fsValueYTD / valueBaseYTDFS - 1) * 100) : notApprovedValue}</td>

					<td className="table__data--small">{obj.isApproved}</td>
				</tr>
				{childrenCollapse}
			</React.Fragment>
		);
	}

	function mapSalesAll(obj: IOverview, i: number): any {

		//const objYTD: IOverview = overviewAllYTDData[i];
		const valueBase: number = getOverviewTS(obj, tstype1);
		const valueBaseFS: number = getOverviewFS(obj, tstype1);
		//const valueBaseYTD: number = getOverviewSL(objYTD, tstype1);
		const tsValue: number = getForecast(obj, forecast); 
		const fsValue: number = getForecast(obj, forecast, true);

		// Se FCT for 0 ignorar valor do YTD
		//const tsValueYTD: number = getForecastYTD(objYTD, forecast, false, obj);
		//const fsValueYTD: number = getForecastYTD(objYTD, forecast, true, obj);

		let valueLYBase: number = 0;
		let tsValueLY: number = 0;
		let fsValueLY: number = 0;
		//let valueBaseLYYTD: number = 0;
		//let tsValueLYYTD: number = 0;
		//let fsValueLYYTD: number = 0;

		if (obj.lastYear != null) {
			valueLYBase = getOverviewTS(obj.lastYear, tstype1);
			tsValueLY = getForecast(obj.lastYear, forecast);
			fsValueLY = getForecast(obj.lastYear, forecast, true);
		}

		/*
		if (objYTD.lastYear != null) {
			valueBaseLYYTD = getOverviewTS(objYTD.lastYear, tstype1);
			tsValueLYYTD = getForecastYTD(objYTD.lastYear, forecast, false, obj);
			fsValueLYYTD = getForecastYTD(objYTD.lastYear, forecast, true, obj);
		}

		const DaysInMonth = new Date(date.getFullYear(), date.getMonth(), 0).getDate();
		const tsYTDByDay = tsValueYTD / DaysInMonth;
		const tsYTDCurrent = Math.round(tsYTDByDay * date.getDate());
		const tsYTDPercent = Math.round((tsYTDCurrent / Math.max(1, tsValue)) * 100);

		const tsYTDLYByDay = tsValueLYYTD / DaysInMonth;
		const tsYTDLYCurrent = Math.round(tsYTDLYByDay * date.getDate());
		const tsYTDLYPercent = Math.round((tsYTDLYCurrent / Math.max(1, tsValueLY)) * 100);

		const fsYTDByDay = fsValueYTD / DaysInMonth;
		const fsYTDCurrent = Math.round(fsYTDByDay * date.getDate());
		const fsYTDPercent = Math.round((fsYTDCurrent / Math.max(1, fsValue)) * 100);

		const fsYTDLYByDay = fsValueLYYTD / DaysInMonth;
		const fsYTDLYCurrent = Math.round(fsYTDLYByDay * date.getDate());
		const fsYTDLYPercent = Math.round((fsYTDLYCurrent / Math.max(1, fsValueLY)) * 100);
		*/

		return (
			<tr key={obj.id + tsValue} className="table__data--totals">
				<td>{obj.name}</td>

				<td>{Formatter.DisplayValue(tsValue)}</td>
				<td>{Formatter.DisplayPercent((tsValue / tsValueLY - 1) * 100)}</td>
				<td className="table__data--border">{Formatter.DisplayPercent((tsValue / valueBase - 1) * 100)}</td>

				<td>{Formatter.DisplayValue(tradeSalesForecast)}</td>
				<td>{Formatter.DisplayPercent((tradeSalesForecast / tradeSalesLastYear - 1) * 100)}</td>
				<td className="table__data--border">{Formatter.DisplayPercent((tradeSalesForecast / tradeSalesReference - 1) * 100)}</td>
				
				<td className="table__separator"></td>

				<td>{Formatter.DisplayValue(fsValue)}</td>
				<td>{Formatter.DisplayPercent((fsValue / fsValueLY - 1) * 100)}</td>
				<td className="table__data--border">{Formatter.DisplayPercent((fsValue / valueBaseFS - 1) * 100)}</td>

				<td>{Formatter.DisplayValue(financialSalesForecast)}</td>
				<td>{Formatter.DisplayPercent((financialSalesForecast / financialSalesLastYear - 1) * 100)}</td>
				<td className="table__data--border">{Formatter.DisplayPercent((financialSalesForecast / financialSalesReference - 1) * 100)}</td>
				
				<td className="table__data--small">{obj.approver}</td>
			</tr>
		);
	}

	function mapWeek(obj: IOverview, isTotalRow: boolean) {
		const valueBase: number = getOverviewTS(obj, tstype4);
		const tsValue: number = getForecast(obj, forecast);
		let tsw1:number = 0;
		let tsw2:number = 0;
		let tsw3:number = 0;
		let tsw4:number = 0; 
		
		if(tweek === "F"){
			tsw1 = obj.tradeSalesForecastWeek1;
			tsw2 = obj.tradeSalesForecastWeek2;
			tsw3 = obj.tradeSalesForecastWeek3;
			tsw4 = obj.tradeSalesForecastWeek4;
		}else{
			tsw1 = obj.tradeSalesMonthTodayWeek1;
			tsw2 = obj.tradeSalesMonthTodayWeek2;
			tsw3 = obj.tradeSalesMonthTodayWeek3;
			tsw4 = obj.tradeSalesMonthTodayWeek4;
		}

		return (
			<tr key={obj.id + valueBase} className={isTotalRow ? "table__data--totals" : ""}>
				<td>{obj.name}</td>

				<td>{Formatter.DisplayValue(valueBase)}</td>
				<td>{Formatter.DisplayValue(tsw1)}</td>
				<td>{Formatter.DisplayValue(tsw2)}</td>
				<td>{Formatter.DisplayValue(tsw3)}</td>
				<td>{Formatter.DisplayValue(tsw4)}</td>
				<td className="table__data--border">{Formatter.DisplayValue(obj.tradeSalesActual)}</td>

				<td className="table__separator"></td>

				<td>{Formatter.DisplayValue(tsValue)}</td>
				<td>{Formatter.DisplayPercent((tsValue / valueBase - 1) * 100)}</td>
				<td>{Formatter.DisplayPercent((tsValue / tsw1 - 1) * 100)}</td>
				<td>{Formatter.DisplayPercent((tsValue / tsw2 - 1) * 100)}</td>
				<td>{Formatter.DisplayPercent((tsValue / tsw3 - 1) * 100)}</td>
				<td>{Formatter.DisplayPercent((tsValue / tsw4 - 1) * 100)}</td>
				<td className="table__data--border">{Formatter.DisplayPercent((obj.tradeSalesActual / tsValue - 1) * 100)}</td>
			</tr>
		);
	}

	function getOverviewData(obj: IOverview): void {
		if (obj.featured)
			overviewDataMajor.push(obj);

		if (obj.children !== null)
			obj.children.forEach((objChild: IOverview) => {
				getOverviewData(objChild);
			});
		else if(!obj.featured)
			overviewData.push(obj);
	}

	function getOverviewYTDData(obj: IOverview): void {
		if (obj.featured)
			overviewYTDDataMajor.push(obj);

		if (obj.children !== null)
			obj.children.forEach((objChild: IOverview) => {
				getOverviewYTDData(objChild);
			});
		else if (!obj.featured)
			overviewYTDData.push(obj);
	}

	function getForecastYTD(objYTD: IOverview, fct:string, isFinancial:boolean, obj:IOverview):number{
		let valueBase: number = 0;

		//consider: (YTD Actual value (closing)) - (current month/week Actual (closing)) + (Forecast value of current month/week)
		if(obj){
			if(isFinancial)
				valueBase = objYTD.financialSalesActual - obj.financialSalesActual;
			else
				valueBase = objYTD.tradeSalesActual - obj.tradeSalesActual;
		}
		
		return valueBase + getForecast(obj, fct, isFinancial);
	}

	function getForecast(obj: IOverview, fct:string, isFinancial?:boolean):number{
		let valueBase: number = 0;

		if(isFinancial){
			valueBase +=
			fct === "FW1" ? obj.financialSalesForecastWeek1 :
			fct === "FW2" ? obj.financialSalesForecastWeek2 :
			fct === "FW3" ? obj.financialSalesForecastWeek3 :
			fct === "FW4" ? obj.financialSalesForecastWeek4 :
							fct === "MTDW1" ? obj.financialSalesMonthTodayWeek1 :
								fct === "MTDW2" ? obj.financialSalesMonthTodayWeek2 :
									fct === "MTDW3" ? obj.financialSalesMonthTodayWeek3 :
											fct === "MTDW4" ? obj.financialSalesMonthTodayWeek4
												: 0;
		}
		else {
			valueBase +=
			fct === "FW1" ? obj.tradeSalesForecastWeek1 :
			fct === "FW2" ? obj.tradeSalesForecastWeek2 :
			fct === "FW3" ? obj.tradeSalesForecastWeek3 :
			fct === "FW4" ? obj.tradeSalesForecastWeek4 :
							fct === "MTDW1" ? obj.tradeSalesMonthTodayWeek1 :
								fct === "MTDW2" ? obj.tradeSalesMonthTodayWeek2 :
									fct === "MTDW3" ? obj.tradeSalesMonthTodayWeek3 :
											fct === "MTDW4" ? obj.tradeSalesMonthTodayWeek4
												: 0;
		}
		return valueBase;
	}

	let g1Total = 0;
	let g1FC: number = 0;
	let g1TotalFS = 0;
	let g1FCFS: number = 0;
	let graph1Data: any = [];
	let graph2Data: any = [];
	let graph3Data: any = [];
	let graph4Data: any = [];
	let graph5Data: any = [];
	let graph6Data: any = [];
	const overviewDataMajor: any = [];
	const overviewYTDDataMajor: any = [];
	let overviewData: any = [];
	let overviewYTDData: any = [];

	let overviewAllData: any = [];
	let overviewAllYTDData: any = [];

	if (!loading) {
		getOverviewData(current!);
		getOverviewYTDData(currentYTD!);

		// Mator Graph1
		g1Total = 0;
		g1FC = 0;
		g1TotalFS = 0;
		g1FCFS = 0;

		overviewDataMajor.forEach((obj: IOverview, index: number) => {
			g1Total += getOverviewTS(obj, tstype2);
			g1FC += getForecast(obj, forecast);
			g1TotalFS += getOverviewFS(obj, tstype5);
			g1FCFS += getForecast(obj, forecast, true);
		});

		graph1Data = [
			{
				category: tstype2,
				value: g1Total
			},
			{
				category: "Forecast",
				value: g1FC
			}
		];
		graph5Data = [
			{
				category: tstype5,
				value: g1TotalFS
			},
			{
				category: "Forecast",
				value: g1FCFS
			}
		];

		let allOthers: IOverview = {
			name: 'All Others',
			tradeSalesActual: 0,
			tradeSalesBusinessPlan: 0,
			tradeSalesFRE: 0,
			tradeSalesLE: 0,
			tradeSalesOP: 0,
			tradeSalesForecastWeek1: 0,
			tradeSalesForecastWeek2: 0,
			tradeSalesForecastWeek3: 0,
			tradeSalesForecastWeek4: 0,
			tradeSalesMonthTodayWeek1: 0,
			tradeSalesMonthTodayWeek2: 0,
			tradeSalesMonthTodayWeek3: 0,
			tradeSalesMonthTodayWeek4: 0,
			tradeSalesSRE: 0,
			year: 0,
			financialSalesActual: 0,
			financialSalesBusinessPlan: 0,
			financialSalesFRE: 0,
			financialSalesSRE: 0,
			financialSalesLE: 0,
			financialSalesOP: 0,
			financialSalesForecastWeek1: 0,
			financialSalesForecastWeek2: 0,
			financialSalesForecastWeek3: 0,
			financialSalesForecastWeek4: 0,
			financialSalesMonthTodayWeek1: 0,
			financialSalesMonthTodayWeek2: 0,
			financialSalesMonthTodayWeek3: 0,
			financialSalesMonthTodayWeek4: 0,
		} as IOverview;
		let allOthersAll: IOverview = {
			name: 'All Others',
			tradeSalesActual: 0,
			tradeSalesBusinessPlan: 0,
			tradeSalesFRE: 0,
			tradeSalesSRE: 0,
			tradeSalesLE: 0,
			tradeSalesOP: 0,
			tradeSalesForecastWeek1: 0,
			tradeSalesForecastWeek2: 0,
			tradeSalesForecastWeek3: 0,
			tradeSalesForecastWeek4: 0,
			tradeSalesMonthTodayWeek1: 0,
			tradeSalesMonthTodayWeek2: 0,
			tradeSalesMonthTodayWeek3: 0,
			tradeSalesMonthTodayWeek4: 0,
			year: 0,
			financialSalesActual: 0,
			financialSalesBusinessPlan: 0,
			financialSalesFRE: 0,
			financialSalesSRE: 0,
			financialSalesLE: 0,
			financialSalesOP: 0,
			financialSalesForecastWeek1: 0,
			financialSalesForecastWeek2: 0,
			financialSalesForecastWeek3: 0,
			financialSalesForecastWeek4: 0,
			financialSalesMonthTodayWeek1: 0,
			financialSalesMonthTodayWeek2: 0,
			financialSalesMonthTodayWeek3: 0,
			financialSalesMonthTodayWeek4: 0,
			lastYear: {
				name: 'All Others',
				tradeSalesActual: 0,
				tradeSalesBusinessPlan: 0,
				tradeSalesFRE: 0,
				tradeSalesSRE: 0,
				tradeSalesLE: 0,
				tradeSalesOP: 0,
				tradeSalesForecastWeek1: 0,
				tradeSalesForecastWeek2: 0,
				tradeSalesForecastWeek3: 0,
				tradeSalesForecastWeek4: 0,
				tradeSalesMonthTodayWeek1: 0,
				tradeSalesMonthTodayWeek2: 0,
				tradeSalesMonthTodayWeek3: 0,
				tradeSalesMonthTodayWeek4: 0,				
				year: 0,
				financialSalesActual: 0,
				financialSalesBusinessPlan: 0,
				financialSalesFRE: 0,
				financialSalesSRE: 0,
				financialSalesForecastWeek1: 0,
				financialSalesForecastWeek2: 0,
				financialSalesForecastWeek3: 0,
				financialSalesForecastWeek4: 0,
				financialSalesMonthTodayWeek1: 0,
				financialSalesMonthTodayWeek2: 0,
				financialSalesMonthTodayWeek3: 0,
				financialSalesMonthTodayWeek4: 0,
			} as IOverview
		} as IOverview;

		overviewData.forEach((obj: IOverview, index: number) => {
			if (obj.level === 1) {
				allOthersAll.tradeSalesActual += obj.tradeSalesActual;
				allOthersAll.tradeSalesBusinessPlan += obj.tradeSalesBusinessPlan;
				allOthersAll.tradeSalesFRE += obj.tradeSalesFRE;
				allOthersAll.tradeSalesSRE += obj.tradeSalesSRE;
				allOthersAll.tradeSalesLE += obj.tradeSalesLE;
				allOthersAll.tradeSalesOP += obj.tradeSalesOP;
				allOthersAll.tradeSalesForecastWeek1 += obj.tradeSalesForecastWeek1;
				allOthersAll.tradeSalesForecastWeek2 += obj.tradeSalesForecastWeek2;
				allOthersAll.tradeSalesForecastWeek3 += obj.tradeSalesForecastWeek3;
				allOthersAll.tradeSalesForecastWeek4 += obj.tradeSalesForecastWeek4;
				allOthersAll.tradeSalesMonthTodayWeek1 += obj.tradeSalesMonthTodayWeek1;
				allOthersAll.tradeSalesMonthTodayWeek2 += obj.tradeSalesMonthTodayWeek2;
				allOthersAll.tradeSalesMonthTodayWeek3 += obj.tradeSalesMonthTodayWeek3;
				allOthersAll.tradeSalesMonthTodayWeek4 += obj.tradeSalesMonthTodayWeek4;
				
				allOthersAll.year = obj.year;
				allOthersAll.financialSalesActual += obj.financialSalesActual;
				allOthersAll.financialSalesBusinessPlan += obj.financialSalesBusinessPlan;
				allOthersAll.financialSalesFRE += obj.financialSalesFRE;
				allOthersAll.financialSalesSRE += obj.financialSalesSRE;
				allOthersAll.financialSalesLE += obj.financialSalesLE;
				allOthersAll.financialSalesOP += obj.financialSalesOP;
				allOthersAll.financialSalesForecastWeek1 += obj.financialSalesForecastWeek1;
				allOthersAll.financialSalesForecastWeek2 += obj.financialSalesForecastWeek2;
				allOthersAll.financialSalesForecastWeek3 += obj.financialSalesForecastWeek3;
				allOthersAll.financialSalesForecastWeek4 += obj.financialSalesForecastWeek4;
				allOthersAll.financialSalesMonthTodayWeek1 += obj.financialSalesMonthTodayWeek1;
				allOthersAll.financialSalesMonthTodayWeek2 += obj.financialSalesMonthTodayWeek2;
				allOthersAll.financialSalesMonthTodayWeek3 += obj.financialSalesMonthTodayWeek3;
				allOthersAll.financialSalesMonthTodayWeek4 += obj.financialSalesMonthTodayWeek4;

				allOthersAll.lastYear.tradeSalesActual += obj.lastYear.tradeSalesActual;
				allOthersAll.lastYear.tradeSalesBusinessPlan += obj.lastYear.tradeSalesBusinessPlan;
				allOthersAll.lastYear.tradeSalesFRE += obj.lastYear.tradeSalesFRE;
				allOthersAll.lastYear.tradeSalesSRE += obj.lastYear.tradeSalesSRE;
				allOthersAll.lastYear.tradeSalesLE += obj.lastYear.tradeSalesLE;
				allOthersAll.lastYear.tradeSalesOP += obj.lastYear.tradeSalesOP;
				allOthersAll.lastYear.tradeSalesForecastWeek1 += obj.lastYear.tradeSalesForecastWeek1;
				allOthersAll.lastYear.tradeSalesForecastWeek2 += obj.lastYear.tradeSalesForecastWeek2;
				allOthersAll.lastYear.tradeSalesForecastWeek3 += obj.lastYear.tradeSalesForecastWeek3;
				allOthersAll.lastYear.tradeSalesForecastWeek4 += obj.lastYear.tradeSalesForecastWeek4;
				allOthersAll.lastYear.tradeSalesMonthTodayWeek1 += obj.lastYear.tradeSalesMonthTodayWeek1;
				allOthersAll.lastYear.tradeSalesMonthTodayWeek2 += obj.lastYear.tradeSalesMonthTodayWeek2;
				allOthersAll.lastYear.tradeSalesMonthTodayWeek3 += obj.lastYear.tradeSalesMonthTodayWeek3;
				allOthersAll.lastYear.tradeSalesMonthTodayWeek4 += obj.lastYear.tradeSalesMonthTodayWeek4;

				allOthersAll.lastYear.year = obj.lastYear.year;
				allOthersAll.lastYear.financialSalesActual += obj.lastYear.financialSalesActual;
				allOthersAll.lastYear.financialSalesBusinessPlan += obj.lastYear.financialSalesBusinessPlan;
				allOthersAll.lastYear.financialSalesFRE += obj.lastYear.financialSalesFRE;
				allOthersAll.lastYear.financialSalesSRE += obj.lastYear.financialSalesSRE;
				allOthersAll.lastYear.financialSalesLE += obj.lastYear.financialSalesLE;
				allOthersAll.lastYear.financialSalesOP += obj.lastYear.financialSalesOP;
				allOthersAll.lastYear.financialSalesForecastWeek1 += obj.lastYear.financialSalesForecastWeek1;
				allOthersAll.lastYear.financialSalesForecastWeek2 += obj.lastYear.financialSalesForecastWeek2;
				allOthersAll.lastYear.financialSalesForecastWeek3 += obj.lastYear.financialSalesForecastWeek3;
				allOthersAll.lastYear.financialSalesForecastWeek4 += obj.lastYear.financialSalesForecastWeek4;
				allOthersAll.lastYear.financialSalesMonthTodayWeek1 += obj.lastYear.financialSalesMonthTodayWeek1;
				allOthersAll.lastYear.financialSalesMonthTodayWeek2 += obj.lastYear.financialSalesMonthTodayWeek2;
				allOthersAll.lastYear.financialSalesMonthTodayWeek3 += obj.lastYear.financialSalesMonthTodayWeek3;
				allOthersAll.lastYear.financialSalesMonthTodayWeek4 += obj.lastYear.financialSalesMonthTodayWeek4;
			}

			if (index > 8) {			
				allOthers.tradeSalesActual += obj.tradeSalesActual;
				allOthers.tradeSalesBusinessPlan += obj.tradeSalesBusinessPlan;
				allOthers.tradeSalesFRE += obj.tradeSalesFRE;
				allOthers.tradeSalesSRE += obj.tradeSalesSRE;
				allOthers.tradeSalesLE += obj.tradeSalesLE;
				allOthers.tradeSalesOP += obj.tradeSalesOP;
				allOthers.tradeSalesForecastWeek1 += obj.tradeSalesForecastWeek1;
				allOthers.tradeSalesForecastWeek2 += obj.tradeSalesForecastWeek2;
				allOthers.tradeSalesForecastWeek3 += obj.tradeSalesForecastWeek3;
				allOthers.tradeSalesForecastWeek4 += obj.tradeSalesForecastWeek4;
				allOthers.tradeSalesMonthTodayWeek1 += obj.tradeSalesMonthTodayWeek1;
				allOthers.tradeSalesMonthTodayWeek2 += obj.tradeSalesMonthTodayWeek2;
				allOthers.tradeSalesMonthTodayWeek3 += obj.tradeSalesMonthTodayWeek3;
				allOthers.tradeSalesMonthTodayWeek4 += obj.tradeSalesMonthTodayWeek4;

				allOthers.year = obj.year;
				allOthers.financialSalesActual += obj.financialSalesActual;
				allOthers.financialSalesBusinessPlan += obj.financialSalesBusinessPlan;
				allOthers.financialSalesFRE += obj.financialSalesFRE;
				allOthers.financialSalesSRE += obj.financialSalesSRE;
				allOthers.financialSalesLE += obj.financialSalesLE;
				allOthers.financialSalesOP += obj.financialSalesOP;
				allOthers.financialSalesForecastWeek1 += obj.financialSalesForecastWeek1;
				allOthers.financialSalesForecastWeek2 += obj.financialSalesForecastWeek2;
				allOthers.financialSalesForecastWeek3 += obj.financialSalesForecastWeek3;
				allOthers.financialSalesForecastWeek4 += obj.financialSalesForecastWeek4;
				allOthers.financialSalesMonthTodayWeek1 += obj.financialSalesMonthTodayWeek1;
				allOthers.financialSalesMonthTodayWeek2 += obj.financialSalesMonthTodayWeek2;
				allOthers.financialSalesMonthTodayWeek3 += obj.financialSalesMonthTodayWeek3;
				allOthers.financialSalesMonthTodayWeek4 += obj.financialSalesMonthTodayWeek4;
			}
		});
		overviewData.splice(9);
		overviewData = overviewData.concat(allOthers);

		// Others Graph2
		g1Total = 0;
		g1FC = 0;
		g1TotalFS = 0;
		g1FCFS = 0;
		overviewData.forEach((obj: IOverview, index: number) => {
			const tsValue = getOverviewTS(obj, tstype6);
			const tsValueFS = getOverviewFS(obj, tstype3);
			const valueBaseG = getForecast(obj, forecast, true);
			const valueBaseGFS = getForecast(obj, forecast);

			g1Total += tsValue;
			g1FC += valueBaseG

			g1TotalFS += tsValueFS;
			g1FCFS += valueBaseGFS

			const gv: number = valueBaseG - tsValue;
			const gvFS: number = valueBaseGFS - tsValueFS;

			if (graph2Data.length === 0)
				graph2Data.push({
					category: obj.name,
					value: gv
				});
			else
				for (let ii = 0; ii <= graph2Data.length; ii++) {
					if (ii === graph2Data.length || gv >= graph2Data[ii].value) {
						graph2Data.splice(ii, 0, {
							category: obj.name,
							value: gv
						});
						break;
					}
				}

			if (graph6Data.length === 0)
				graph6Data.push({
					category: obj.name,
					value: gvFS
				});
			else
				for (let ii = 0; ii <= graph6Data.length; ii++) {
					if (ii === graph6Data.length || gvFS >= graph6Data[ii].value) {
						graph6Data.splice(ii, 0, {
							category: obj.name,
							value: gvFS
						});
						break;
					}
				}


		});
		graph2Data.splice(0, 0, {
			category: tstype3,
			value: g1Total
		});
		graph2Data.push({
			category: "Forecast",
			value: g1FC
		});

		graph6Data.splice(0, 0, {
			category: tstype6,
			value: g1TotalFS
		});
		graph6Data.push({
			category: "Forecast",
			value: g1FCFS
		});

		graph3Data = getWeekGraphData(overviewDataMajor, tsWeek1);
		graph4Data = getWeekGraphData(overviewData, tsWeek2);

		//overviewAllData = [allOthersAll, current];
		overviewAllData = [current];

		allOthers = {
			name: 'All Others',
			tradeSalesActual: 0,
			tradeSalesBusinessPlan: 0,
			tradeSalesFRE: 0,
			tradeSalesSRE: 0,
			tradeSalesLE: 0,
			tradeSalesOP: 0,
			tradeSalesForecastWeek1: 0,
			tradeSalesForecastWeek2: 0,
			tradeSalesForecastWeek3: 0,
			tradeSalesForecastWeek4: 0,
			tradeSalesMonthTodayWeek1: 0,
			tradeSalesMonthTodayWeek2: 0,
			tradeSalesMonthTodayWeek3: 0,
			tradeSalesMonthTodayWeek4: 0,
			year: 0,
			financialSalesActual: 0,
			financialSalesBusinessPlan: 0,
			financialSalesFRE: 0,
			financialSalesSRE: 0,
			financialSalesLE: 0,
			financialSalesOP: 0,
			financialSalesForecastWeek1: 0,
			financialSalesForecastWeek2: 0,
			financialSalesForecastWeek3: 0,
			financialSalesForecastWeek4: 0,
			financialSalesMonthTodayWeek1: 0,
			financialSalesMonthTodayWeek2: 0,
			financialSalesMonthTodayWeek3: 0,
			financialSalesMonthTodayWeek4: 0,
		} as IOverview;
		allOthersAll = {
			name: 'All Others',
			tradeSalesActual: 0,
			tradeSalesBusinessPlan: 0,
			tradeSalesFRE: 0,
			tradeSalesSRE: 0,
			tradeSalesLE: 0,
			tradeSalesOP: 0,
			tradeSalesForecastWeek1: 0,
			tradeSalesForecastWeek2: 0,
			tradeSalesForecastWeek3: 0,
			tradeSalesForecastWeek4: 0,
			tradeSalesMonthTodayWeek1: 0,
			tradeSalesMonthTodayWeek2: 0,
			tradeSalesMonthTodayWeek3: 0,
			tradeSalesMonthTodayWeek4: 0,
			year: 0,
			financialSalesActual: 0,
			financialSalesBusinessPlan: 0,
			financialSalesFRE: 0,
			financialSalesSRE: 0,
			financialSalesLE: 0,
			financialSalesOP: 0,
			financialSalesForecastWeek1: 0,
			financialSalesForecastWeek2: 0,
			financialSalesForecastWeek3: 0,
			financialSalesForecastWeek4: 0,
			financialSalesMonthTodayWeek1: 0,
			financialSalesMonthTodayWeek2: 0,
			financialSalesMonthTodayWeek3: 0,
			financialSalesMonthTodayWeek4: 0,
		} as IOverview;

		overviewYTDData.forEach((obj: IOverview, index: number) => {			
			allOthersAll.tradeSalesActual += obj.tradeSalesActual;
			allOthersAll.tradeSalesBusinessPlan += obj.tradeSalesBusinessPlan;
			allOthersAll.tradeSalesFRE += obj.tradeSalesFRE;
			allOthersAll.tradeSalesSRE += obj.tradeSalesSRE;
			allOthersAll.tradeSalesLE += obj.tradeSalesLE;
			allOthersAll.tradeSalesOP += obj.tradeSalesOP;
			allOthersAll.tradeSalesForecastWeek1 += obj.tradeSalesForecastWeek1;
			allOthersAll.tradeSalesForecastWeek2 += obj.tradeSalesForecastWeek2;
			allOthersAll.tradeSalesForecastWeek3 += obj.tradeSalesForecastWeek3;
			allOthersAll.tradeSalesForecastWeek4 += obj.tradeSalesForecastWeek4;
			allOthersAll.tradeSalesMonthTodayWeek1 += obj.tradeSalesMonthTodayWeek1;
			allOthersAll.tradeSalesMonthTodayWeek2 += obj.tradeSalesMonthTodayWeek2;
			allOthersAll.tradeSalesMonthTodayWeek3 += obj.tradeSalesMonthTodayWeek3;
			allOthersAll.tradeSalesMonthTodayWeek4 += obj.tradeSalesMonthTodayWeek4;

			allOthersAll.year = obj.year;
			allOthersAll.financialSalesActual += obj.financialSalesActual;
			allOthersAll.financialSalesBusinessPlan += obj.financialSalesBusinessPlan;
			allOthersAll.financialSalesFRE += obj.financialSalesFRE;
			allOthersAll.financialSalesSRE += obj.financialSalesSRE;
			allOthersAll.financialSalesLE += obj.financialSalesLE;
			allOthersAll.financialSalesOP += obj.financialSalesOP;
			allOthersAll.financialSalesForecastWeek1 += obj.financialSalesForecastWeek1;
			allOthersAll.financialSalesForecastWeek2 += obj.financialSalesForecastWeek2;
			allOthersAll.financialSalesForecastWeek3 += obj.financialSalesForecastWeek3;
			allOthersAll.financialSalesForecastWeek4 += obj.financialSalesForecastWeek4;
			allOthersAll.financialSalesMonthTodayWeek1 += obj.financialSalesMonthTodayWeek1;
			allOthersAll.financialSalesMonthTodayWeek2 += obj.financialSalesMonthTodayWeek2;
			allOthersAll.financialSalesMonthTodayWeek3 += obj.financialSalesMonthTodayWeek3;
			allOthersAll.financialSalesMonthTodayWeek4 += obj.financialSalesMonthTodayWeek4;

			if (index > 8) {
				allOthers.tradeSalesActual += obj.tradeSalesActual;
				allOthers.tradeSalesBusinessPlan += obj.tradeSalesBusinessPlan;
				allOthers.tradeSalesFRE += obj.tradeSalesFRE;
				allOthers.tradeSalesSRE += obj.tradeSalesSRE;
				allOthers.tradeSalesLE += obj.tradeSalesLE;
				allOthers.tradeSalesOP += obj.tradeSalesOP;
				allOthers.tradeSalesForecastWeek1 += obj.tradeSalesForecastWeek1;
				allOthers.tradeSalesForecastWeek2 += obj.tradeSalesForecastWeek2;
				allOthers.tradeSalesForecastWeek3 += obj.tradeSalesForecastWeek3;
				allOthers.tradeSalesForecastWeek4 += obj.tradeSalesForecastWeek4;
				allOthers.tradeSalesMonthTodayWeek1 += obj.tradeSalesMonthTodayWeek1;
				allOthers.tradeSalesMonthTodayWeek2 += obj.tradeSalesMonthTodayWeek2;
				allOthers.tradeSalesMonthTodayWeek3 += obj.tradeSalesMonthTodayWeek3;
				allOthers.tradeSalesMonthTodayWeek4 += obj.tradeSalesMonthTodayWeek4;

				allOthers.year = obj.year;
				allOthers.financialSalesActual += obj.financialSalesActual;
				allOthers.financialSalesBusinessPlan += obj.financialSalesBusinessPlan;
				allOthers.financialSalesFRE += obj.financialSalesFRE;
				allOthers.financialSalesSRE += obj.financialSalesSRE;
				allOthers.financialSalesLE += obj.financialSalesLE;
				allOthers.financialSalesOP += obj.financialSalesOP;
				allOthers.financialSalesForecastWeek1 += obj.financialSalesForecastWeek1;
				allOthers.financialSalesForecastWeek2 += obj.financialSalesForecastWeek2;
				allOthers.financialSalesForecastWeek3 += obj.financialSalesForecastWeek3;
				allOthers.financialSalesForecastWeek4 += obj.financialSalesForecastWeek4;
				allOthers.financialSalesMonthTodayWeek1 += obj.financialSalesMonthTodayWeek1;
				allOthers.financialSalesMonthTodayWeek2 += obj.financialSalesMonthTodayWeek2;
				allOthers.financialSalesMonthTodayWeek3 += obj.financialSalesMonthTodayWeek3;
				allOthers.financialSalesMonthTodayWeek4 += obj.financialSalesMonthTodayWeek4;
			}
		});
		overviewYTDData.splice(9);
		overviewYTDData = overviewYTDData.concat(allOthers);

		//overviewAllYTDData = [allOthersAll, current];
		overviewAllYTDData = [allOthers];
	}

	//this needs to be proccessed before latamTotal
	var allChildren = overviewDataMajor.map((obj: IOverview, i: number) => mapSalesMajor("", obj, overviewYTDDataMajor[i]));
	var latamTotal = overviewAllData.map(mapSalesAll);

	return (
		<React.Fragment>
			{loading ? (
				<Loading />
			) : (
					<React.Fragment>
						<section className="content__block">
							{/* <p>Table 1</p> */}
							<div className="content__header">
								<h2 className="content__title">Off Premise - {current!.code}</h2>
								<div className="multi-selects">
									<div className="content__select">
										<Select
											className="select-custom select-custom--medium select-custom--shadow"
											name="month"
											title="Month"
											options={months.map(mapList)}
											value={month}
											handleChange={(event: React.FormEvent<HTMLSelectElement>) => {
												var value = +event.currentTarget.value;
												if (value)
													setMonth(value);
											}}
										/>
									</div>
									<div className="content__select">
										<Select
											className="select-custom select-custom--medium select-custom--shadow"
											name="year"
											title="Year"
											options={years.map((obj) => { return { value: obj.name, label: obj.name } })}
											value={year}
											handleChange={(event: React.FormEvent<HTMLSelectElement>) => {
												var value = +event.currentTarget.value;
												if (value)
													setYear(value);
											}}
										/>
									</div>
								</div>
							</div>

							<div className="content__select">
								<Select
									name="tstype1"
									title="Reference"
									options={[
										{ value: "BP", label: "BP" },
										{ value: "FRE", label: "FRE" },
										{ value: "SRE", label: "SRE" },
										{ value: "LE", label: "LE" },
										{ value: "OP", label: "OP" }
									]}
									value={tstype1}
									handleChange={(event: React.FormEvent<HTMLSelectElement>) => {
										setType1(event.currentTarget.value);
									}}
								/>
								&nbsp;
								<Select
									name="forecast"
									title="Forecast"
									options={[
										{ value: "FW1", label: "FW1" },
										{ value: "FW2", label: "FW2" },
										{ value: "FW3", label: "FW3" },
										{ value: "FW4", label: "FW4" },
										{ value: "MTDW1", label: "MTDW1" },
										{ value: "MTDW2", label: "MTDW2" },
										{ value: "MTDW3", label: "MTDW3" },
										{ value: "MTDW4", label: "MTDW4" }
									]}
									value={forecast}
									handleChange={(event: React.FormEvent<HTMLSelectElement>) => {
										setForecast(event.currentTarget.value);
									}}
								/>
							</div>

							<div className="table table--last-th-stylized">
								<table className="table__data has-table__data--totals table--row-align-text-right">
									<tbody>
										<tr className="table__data--borderless">
											
											<td colSpan={7} style={{'width': '50%'}}>
												<span className="table__title">Trade Sales</span>
											</td>
											<td className="table__separator"></td>
											<td colSpan={7} style={{'width': '50%'}}>
												<span className="table__title">Financial Sales</span>
											</td>
											
										</tr>
										<tr className="table__data--borderless">
											<td></td>
											<td colSpan={3}>
												<span className="table_subtitle">
													FORECAST {current!.year}
												</span>
											</td>
											<td colSpan={3}>
												<span className="table_subtitle">YTD</span>
											</td>
											<td className="table__separator"></td>
											<td colSpan={3}>
												<span className="table_subtitle">
													FORECAST {current!.year}
												</span>
											</td>
											<td colSpan={3}>
												<span className="table_subtitle">YTD</span>
											</td>
											<td></td>
										</tr>
										<tr>
											<th>BUSINESS <br />UNIT</th>
											<th>{forecast}</th>
											<th>VS. LY</th>
											<th>VS. {tstype1}</th>

											<th>{forecast}</th>
											<th>VS. LY</th>
											<th>VS. {tstype1}</th>
											
											<th className="table__separator"></th>

											<th>{forecast}</th>
											<th>VS. LY</th>
											<th>VS. {tstype1}</th>

											<th>{forecast}</th>
											<th>VS. LY</th>
											<th>VS. {tstype1}</th>

											<th>SIGNED <br />OFF BY</th>
										</tr>
										{latamTotal}
										{allChildren}
									</tbody>
								</table>
							</div>
						</section>

						<section className="content__block">
							{/* <p>GRAPH 1 (graph1Data)</p> */}
							<h2 className="content__title">Trade Sales</h2>

							<div className="content__select">
								<Select
									name="tstype2"
									title="Reference"
									options={[
										{ value: "BP", label: "BP" },
										{ value: "FRE", label: "FRE" },
										{ value: "SRE", label: "SRE" },
										{ value: "LE", label: "LE" },
										{ value: "OP", label: "OP" }										
									]}
									value={tstype2}
									handleChange={(event: React.FormEvent<HTMLSelectElement>) => {
										setType2(event.currentTarget.value);
									}}
								/>
							</div>

							<Waterfall
								id={"chart1div"}
								data={graph1Data}
							/>
						</section>

						<section className="content__block">
							{/* <p>GRAPH 2 - OLD GRAPH 4 (graph6Data)</p> */}
							<div className="content__select">
								<Select
									name="tstype6"
									title="Reference"
									options={[
										{ value: "BP", label: "BP" },
										{ value: "FRE", label: "FRE" },
										{ value: "SRE", label: "SRE" },
										{ value: "LE", label: "LE" },
										{ value: "OP", label: "OP" }
									]}
									value={tstype6}
									handleChange={(event: React.FormEvent<HTMLSelectElement>) => {
										setType6(event.currentTarget.value);
									}}
								/>
							</div>

							<Waterfall
								id={"chart6div"}
								data={graph6Data}
							/>
						</section>

						<section className="content__block">
							{/* <p>GRAPH 3 (graph5Data)</p> */}
							<h2 className="content__title">Financial Sales</h2>
							<div className="content__select">
								<Select
									name="tstype5"
									title="Reference"
									options={[
										{ value: "BP", label: "BP" },
										{ value: "FRE", label: "FRE" },
										{ value: "SRE", label: "SRE" },
										{ value: "LE", label: "LE" },
										{ value: "OP", label: "OP" }
									]}
									value={tstype5}
									handleChange={(event: React.FormEvent<HTMLSelectElement>) => {
										setType5(event.currentTarget.value);
									}}
								/>
							</div>

							<Waterfall
								id={"chart5div"}
								data={graph5Data}
							/>
						</section>

						<section className="content__block">
							{/* <p>GRAPH 4 - OLD GRAPH 2 (graph2Data)</p> */}
							<div className="content__select">
								<Select
									name="tstype3"
									title="Reference"
									options={[
										{ value: "BP", label: "BP" },
										{ value: "FRE", label: "FRE" },
										{ value: "SRE", label: "SRE" },
										{ value: "LE", label: "LE" },
										{ value: "OP", label: "OP" }
									]}
									value={tstype3}
									handleChange={(event: React.FormEvent<HTMLSelectElement>) => {
										setType3(event.currentTarget.value);
									}}
								/>
							</div>

							<Waterfall
								id={"chart2div"}
								data={graph2Data}
							/>
						</section>
						
						<section className="content__block">
							{/* <p>Table 2</p> */}
							<div className="content__select">
								<Select
									name="tstype4"
									title="Reference"
									options={[
										{ value: "BP", label: "BP" },
										{ value: "FRE", label: "FRE" },
										{ value: "SRE", label: "SRE" },
										{ value: "LE", label: "LE" },
										{ value: "OP", label: "OP" }
									]}
									value={tstype4}
									handleChange={(event: React.FormEvent<HTMLSelectElement>) => {
										setType4(event.currentTarget.value);
									}}
								/>
								&nbsp;
								<Select
									name="tweek"
									title="Week"
									options={[
										{ value: "F", label: "Forecast" },
										{ value: "MTD", label: "Month to Date" },
									]}
									value={tweek}
									handleChange={(event: React.FormEvent<HTMLSelectElement>) => {
										setTypeWeek(event.currentTarget.value);
									}}
								/>
							</div>

							<div className="table">
								<table className="table__data has-table__data--totals table--row-align-text-right">
									<tbody>
										<tr className="table__data--borderless">
											<td colSpan={15}>
												<span className="table_subtitle">WEEKLY COMPARISON</span>
											</td>
										</tr>
										<tr>
											<th>BUSINESS <br />UNIT</th>

											<th>{tstype4}</th>
											<th>W1</th>
											<th>W2</th>
											<th>W3</th>
											<th>W4</th>
											<th>CLOSING</th>
											
											<th className="table__separator"></th>

											<th>{forecast}</th>
											<th>VS. {tstype4}</th>
											<th>VS W1</th>
											<th>VS W2</th>
											<th>VS W3</th>
											<th>VS W4</th>
											<th>VS CLOSING</th>
										</tr>
										{overviewAllData.map((obj: IOverview) => mapWeek(obj, true))}
										{overviewDataMajor.map((obj: IOverview) => mapWeek(obj, false))}
									</tbody>
								</table>
							</div>
						</section>

					</React.Fragment>
				)}
		</React.Fragment>
	);
};

export default Overview;
